import React from "react";

export const CupraResult = ({ result, formatCurrency, calcPercent }) => {
  const rows = [];
  if (result.sale_category === "SOCIETE") rows.push(["company", `Marge société ${result.company_type} · base incluse`, result.company_aid]);
  else if (result.sale_category === "DEAL") rows.push(["deal", "Marge DEAL · base incluse", result.cupra_deal_margin]);
  else {
    rows.push(["base", "Marge de base", result.base_margin]);
    rows.push(["prime", "Prime systématique", result.systematic_prime]);
    if (result.vd_aid > 0) rows.push(["vd", "Mise à la route VD", result.vd_aid]);
    if (result.vdr_aid > 0) rows.push(["vdr", "Mise à la route VDR", result.vdr_aid]);
    if (result.trade_in_bonus > 0) rows.push(["trade", "Reprise toutes marques", result.trade_in_bonus]);
    if (result.reprise_mini_bonus > 0) rows.push(["mini", "Reprise Mini", result.reprise_mini_bonus]);
  }
  if (result.exceptional_aid > 0) rows.push(["exceptional", "Aide exceptionnelle", result.exceptional_aid]);
  return rows.map(([key, label, amount]) => <div key={key} data-testid={`cupra-result-${key}-row`} className="flex flex-wrap justify-between gap-2">
    <span>{label}</span><span data-testid={`cupra-result-${key}-amount`} className="font-data">{formatCurrency(amount)} <span className="text-xs text-muted-foreground">{calcPercent(amount)}</span></span>
  </div>);
};